
import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const ADD_WORKSPACE = `[${ModuleConfiguration.moduleName}] Add Workspace`;

export class AddWorkspaceAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ADD_WORKSPACE;

  constructor(public payload: { entityKey: string, scope?: string, parentEntityKey: string, parentKey: string }) {}
}




// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/AddWorkspaceAction.ts